import { useCallback, useMemo, useState } from "react";

import { Switch, SwitchField } from "V2.0/common/switch";
import { Label, Description } from "V2.0/common/fieldset";

export function useIgnorePreviousCampaigns() {
  const [isIgnorePreviousCampaigns, setIsIgnorePreviousCampaigns] =
    useState(false);

  const toggleIgnorePreviousCampaigns = useCallback(() => {
    setIsIgnorePreviousCampaigns((prevState) => !prevState);
  }, [setIsIgnorePreviousCampaigns]);

  const value = useMemo(() => {
    return {
      isIgnorePreviousCampaigns,
      toggleIgnorePreviousCampaigns,
    };
  }, [isIgnorePreviousCampaigns, toggleIgnorePreviousCampaigns]);

  return value;
}

export default function IgnorePreviousCampaigns(props) {
  const { isIgnored, onToggleIgnore } = props;

  return (
    <div className="my-8">
      <SwitchField>
        <Label>Ignore Previous Campaigns</Label>
        <Description>
          Ignore contact's campaign history and reach out again
        </Description>
        <Switch
          color="emerald"
          checked={isIgnored}
          onClick={onToggleIgnore}
        />
      </SwitchField>
    </div>
  );
}
